import { Col, Divider, Row, Typography } from "antd";
import React from "react";

type DataDisplayRowProps = {
  label: string;
  value?: React.ReactNode;
  valueFallback?: React.ReactNode;
  labelColSpan?: number;
  withDivider?: boolean;
};

export const DataDisplayRow = (props: DataDisplayRowProps) => {
  const { label, value, valueFallback = "-", labelColSpan = 12, withDivider = true } = props;

  return (
    <>
      <Row>
        <Col span={labelColSpan}>
          <Typography.Text className="ag-primary" strong>
            {label}
          </Typography.Text>
        </Col>
        <Col flex="1">
          <Typography.Text className="smallFont14 fontWeight600">{value ?? valueFallback}</Typography.Text>
        </Col>
      </Row>
      {withDivider && <Divider />}
    </>
  );
};
